import React from 'react';
import './TechnologyStack.css';
import { useLanguage } from '../contexts/LanguageContext';

const TechnologyStack = () => {
  const { t } = useLanguage();
  
  return (
    <div className="technology-stack" id="technology">
      <div className="container">
        <h1 className="section-title">{t('technologyStack.title')}</h1>
        <p className="section-description">
          {t('technologyStack.description')}
        </p>
        
        <div className="technology-grid">
          <div className="tech-card tech-card--large">
            <div className="card-image-container">
              <img src="/images/site-gorselleri-efektli/7.png" alt="NVIDIA Jetson Thor" className="card-image" />
            </div>
            <div className="card-content">
              <h2 className="card-title">{t('technologyStack.cards.0.title')}</h2>
              <p className="card-description">
                {t('technologyStack.cards.0.description')}
              </p>
            </div>
          </div>

          <div className="side-by-side-cards">
            <div className="tech-card tech-card--medium">
              <div className="card-image-container">
                <img src="/images/site-gorselleri-efektli/8.PNG" alt="NVIDIA Isaac Sim / Omniverse" className="card-image" />
              </div>
              <div className="card-content">
                <h2 className="card-title">{t('technologyStack.cards.1.title')}</h2>
                <p className="card-description">
                  {t('technologyStack.cards.1.description')}
                </p>
              </div>
            </div>

            <div className="tech-card tech-card--tall">
              <div className="card-image-container">
                <img src="/images/site-gorselleri-efektli/11.PNG" alt="Project Gr00t Foundation Model" className="card-image" />
              </div>
              <div className="card-content">
                <h2 className="card-title">{t('technologyStack.cards.2.title')}</h2>
                <p className="card-description">
                  {t('technologyStack.cards.2.description')}
                </p>
              </div>
            </div>
          </div>

          <div className="tech-card tech-card--small">
            <div className="card-image-container">
              <img src="/images/site-gorselleri-efektli/9.PNG" alt="NVIDIA Isaac Perceptor" className="card-image" />
            </div>
            <div className="card-content">
              <h2 className="card-title">{t('technologyStack.cards.3.title')}</h2>
              <p className="card-description">
                {t('technologyStack.cards.3.description')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechnologyStack; 